import { render, staticRenderFns } from "./policyExpressList.vue?vue&type=template&id=5fda460c&scoped=true"
import script from "./policyExpressList.vue?vue&type=script&lang=js"
export * from "./policyExpressList.vue?vue&type=script&lang=js"
import style0 from "./policyExpressList.vue?vue&type=style&index=0&id=5fda460c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda460c",
  null
  
)

export default component.exports